import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Sidebar from '../Sidebar/Sidebar'
import CollectionSidebar from './CollectionSidebar';
import singleDepartemnt from '../../services/departmentsService'
import Loader from "react-loader-spinner";
import './Collection.css'
class CollectionList extends Component {
    state = {
      user:{},
      collections:[],
      department:{},
      newCollectionItem:{},
      showCollectionItemModal:false,
      showCollectionItemActions:false,
      isLoading:true,
      isInitiallyLoaded:true
    }
     async componentDidMount(){
      let loggedInUser = localStorage.getItem('currentUser')
      let { id } = this.props.match.params
      let response = await singleDepartemnt.fetchSingleDepartment(id)
      let department = await response.data
      let { collections } = await response.data
      loggedInUser = JSON.parse(loggedInUser)
      this.setState({department})
      this.setState({collections})
      this.setState({showCollectionItemActions:true})
      this.setState({user:loggedInUser})
      this.setState({isLoading:false})
      this.setState({isInitiallyLoaded:false})
     };

     newCollectionItemInsertion = () => {
       this.setState({showCollectionItemModal:true})
     }
     closeAdd = () => {
      this.setState({showCollectionItemModal : false})
  }

    render() {
      let { user,department ,collections,showCollectionItemActions,isLoading } = this.state
      let { id:departmentId } = this.props.match.params
        return (
            this.state.isInitiallyLoaded ?
            <div className="flex items-center justify-center h-screen">
                <Loader type="Oval" className="align-middle" color="#F35D2D" height={100} width={100}/>
            </div>  :
            <div className="flex flex-row w-full">
                <div className="fixed z-10 p-4 bg-white  md:min-h-screen w-60">
                <Sidebar user={user}/>
                </div>
                <div className="relative px-8 py-8 ml-60 upPart lg:max-h-48">
                   <div className="w-full">
                      <div className="flex text-white">
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>
                        <Link to="/departments">
                          <span className="ml-2">
                             Go back to departments List
                          </span>
                        </Link>
                      </div>
                      <div className="mt-4">
                        <div className="flex">
                        <span className="text-2xl font-bold text-white">{department.title} Department</span>
                        <div className="flex my-1 ml-24">
                        <div style={{ backgroundColor:"#ff944d" }} className="flex items-center justify-center w-6 h-6 text-white rounded-full">
                              <svg className="w-4 h-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" /></svg>
                        </div>
                        <span className="ml-2 text-white font-tight">{collections.length} Collections</span>
                        </div>
                        </div>
                      </div>
                   </div>
                   <div  className="w-full mt-8 ">
                       <div className="min-w-full pt-2">
                           <CollectionSidebar departmentId = {departmentId} collections = {collections} isLoading={isLoading}/>
                       </div>
                   </div> 
                </div>
            </div>
        )
    }
}

export default CollectionList;
